import React from 'react';
import { BaseLink } from '../link/base-link';
/**
 * Create a link to show in alerts
 *
 * @param config AlertLink config
 * @param className any className to apply to the link (used for margins)
 *
 * @return JSX of alert link
 */
export const createActionLink = (config, className) => (React.createElement(BaseLink, { tabIndex: 0, ref: config.ref, className: className, href: config.isDisabled ? undefined : config.link, target: config.openLinkInNewTab ? '_blank' : undefined, onClick: config.isDisabled ? undefined : config.onClick, onKeyDown: (event) => {
        if (event.key === 'Enter' && config.onEnter && !config.isDisabled) {
            config.onEnter(event);
        }
    }, rel: "noreferrer", "data-tooltip-content": config.tooltipContent }, config.label));
/**
 * Get path to the svg illustration from radiant-styles module
 *
 * @param filename svg file name
 */
export const getMutedAlertSVGPath = (filename) => `/node_modules/@thoughtspot/radiant-styles/public/img/illustrations/${filename}.svg`;
//# sourceMappingURL=alert-utils.js.map